    import formulajs from '@formulajs/formulajs';

    export const PredBoundaries = (type, muscle, patient) => {
        // calculation of upper and lower predicted boundaries
        // set type to 0 for predicted strength, 1 for lower boundary and 2 for upper boundary

        const age = patient.age;
        const weight = patient.weight;
        const gender = patient.gender === 'female' ? 0 : 1;

        function age_gender_indicator() {
        // used in all of the other calculations, based on age and gender
            if (age > 13) {
                return (age - 13) * gender;
            } else {
                return 0;
            }
        };

        function ln_yhatt(indicator) {
            // used in calculations of predicted strength; based on the constant, ln_age and ln_weight value on each muscle
            return muscle.constant + muscle.ln_age * Math.log(age) + muscle.ln_weight * Math.log(weight) + muscle.age_x_gender * indicator;
        };

        function inverse_matrix(indicator) {
            // used in calculation upper and lower prediction, based on the inverse matrix on each muscle
            // values are the same for these groups: (hip_flex1, hip_abd,  knee_ext, knee_flex, foot_dors), (eb_ext, eb_flex, hand_dorsal)
            function matrix_part(x) {
                if (muscle.matrix.length) {
                    return muscle.matrix[x][0] + muscle.matrix[x][1] * Math.log(age) + muscle.matrix[x][2] * Math.log(weight) + muscle.matrix[x][3] * indicator;
                }

                return 0
            }

            return matrix_part(0) + Math.log(age) * matrix_part(1) + Math.log(weight) * matrix_part(2) + indicator * matrix_part(3);
        };


        // final calculations here, based on above formulas

        let yhatt = ln_yhatt(age_gender_indicator());

        let matrix = inverse_matrix(age_gender_indicator());

        let t_stat = formulajs.TINV['2T'](0.05, muscle.freedom);
           
        if (type == 0) {
            // predicted
            if (yhatt == 0) {
                // case with f_plant that has no values
                return 0
            } else {
                return Math.exp(yhatt);
            }
        } else if (type == 1) {
            // lower boundary
            return Math.exp(yhatt - t_stat * Math.sqrt(muscle.s2 * (1 + matrix)));
        }
        else if (type == 2) {
            // upper boundary
            return Math.exp(yhatt + t_stat * Math.sqrt(muscle.s2 * (1 + matrix)));
        }
    }

    export const NMStrength = (side, muscle, values) => {
        
        // for side, use 1 for right and 2 for left
        for (let value of values) {
            if (value.group == muscle.id) {
                let v_side;

                if (side == 1) {
                    v_side = value.right;
                } else if (side == 2) {
                    v_side = value.left;
                }
                // [0], [1] and [2] are the measured values, [3] is the lever
                return Math.max(v_side[0], v_side[1], v_side[2]) * v_side[3]*0.01;
            }
            
        }
    }

    export const PercStrength = (age, measuredvalue, predictedvalue) => {
        if(age > 4.5 && age < 16.5) {
            return 100 * measuredvalue / predictedvalue;
        } else {
            return 0;
        }
    }

    export const FormatAndRound = (digits, num) => {
        if (typeof(num) == 'number') {
            return new Intl.NumberFormat().format(parseFloat(num).toFixed(digits));
        } else {
            return num;
        }
    }
